import { SET_CAROUSEL_BOTTOM_HEIGHT } from 'actions';
import { CarouselReduxReducer } from 'typings';

export function setCarouselBottomHeight(
  reduxReducer: CarouselReduxReducer,
  bottomHeight: number,
) {
  return { bottomHeight, reduxReducer, type: SET_CAROUSEL_BOTTOM_HEIGHT };
}
